<template>
  <div class="xd-toast-wrap">
    <transition-group name="fade">
      <Notice
        v-for="notice in notices"
        :key="notice.name"
        :name="notice.name"
        :content="notice.content"
        :duration="notice.duration"
        :on-close="notice.onClose"
      />
    </transition-group>
  </div>
</template>

<script>
import Notice from './notice.vue';

export default {
  name: 'CommonXDToast',
  props: {
    content: String,
  },
  components: { Notice },

  data() {
    return {
      notices: [],
    };
  },

  methods: {
    add(props) {
      this.notices.push(props);
    },

    close(name) {
      for (let i = 0; i < this.notices.length; i++) {
        if (this.notices[i].name === name) {
          this.notices.splice(i, 1);
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.xd-toast {
  &-wrap {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1000;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>